import apiClient from "./apiClient";

const zonesEndpoint = "/zones";

/**
 * La corrección es usar .get() para indicar que es una petición GET.
 * Además, con .then(res => res.data) nos aseguramos de que el componente
 * que llame a la función reciba directamente los datos que necesita.
 */
export const getAllZones = async () => {
  try {
    const response = await apiClient.get("/zones/allZones"); // Ajusta a tu ruta real
    return response.data;
  } catch (error) {
    console.error("Error fetching zones:", error);
    throw error;
  }
};

export const getAllResidentialZones = async () =>
  apiClient.get(`${zonesEndpoint}/residentials`).then((res) => res.data);

export const getAllPatrimonialZones = async () =>
  apiClient.get(`${zonesEndpoint}/patrimonials`).then((res) => res.data);

export const getAllOthersZones = async () =>
  apiClient.get(`${zonesEndpoint}/others`).then((res) => res.data);

export const getAllCostaZones = async () =>
  apiClient.get(`${zonesEndpoint}/costa`).then((res) => res.data);

export const getAllRusticAndSingularZones = async () =>
  apiClient.get(`${zonesEndpoint}/rustic-and-singular`).then((res) => res.data);

export const getGroupedZones = async () =>
  apiClient.get(`${zonesEndpoint}/grouped`).then((res) => res.data);

export const updateZoneDescriptionApi = async (zoneId, description) => {
  try {
    // Usamos el apiClient con el método patch y pasamos el objeto directamente
    const response = await apiClient.patch(
      `${zonesEndpoint}/${zoneId}/description`,
      {
        zoneDescription: description,
      },
    );

    // apiClient (si es Axios) ya te formatea la respuesta en .data
    return response.data;
  } catch (error) {
    console.error("Error en updateZoneDescriptionApi:", error);
    throw error; // Lanzamos el error para que lo atrape el bloque catch del frontend
  }
};

// api/zones.api.js
